/* JP Racing stage kits: stepped picker (v3.1).
   1) Only the Model section shows first.
   2) Picking a model reveals the Stage section with only that model's stages.
   3) Picking a stage reveals the Package section with only that kit's packages.
   Add to cart stays locked until a complete, real kit is chosen.
   Robust to Dawn re-rendering the picker: every pass re-reads the live DOM and a
   MutationObserver re-applies the filtering after any section swap.
   Scoped to the stage kits product; if anything fails to load, Dawn's default picker remains. */
(function () {
  var HANDLE = 'jp-racing-sea-doo-stage-kits';
  if (window.location.pathname.indexOf('/products/' + HANDLE) === -1) return;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    fetch('/products/' + HANDLE + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (product) { init(product); })
      .catch(function () { /* leave Dawn default behavior */ });

    function init(product) {
      var variants = (product.variants || []).map(function (v) { return v.options; });
      if (!variants.length) return;

      var style = document.createElement('style');
      style.textContent = '.jp-picker-locked .product-form__buttons, .jp-picker-locked .shopify-payment-button { opacity:.45; pointer-events:none; }';
      document.head.appendChild(style);

      function getVS() { return document.querySelector('variant-selects[data-product-handle="' + HANDLE + '"]') || document.querySelector('variant-selects'); }
      function getGroups(vs) { return Array.prototype.slice.call(vs.querySelectorAll('.product-form__input')); }
      function valueOf(g) {
        var sel = g.querySelector('select');
        if (sel) return sel.value || null;
        var c = g.querySelector('input[type="radio"]:checked');
        return c ? c.value : null;
      }
      function setValue(g, val) {
        var sel = g.querySelector('select');
        if (sel) { if (sel.value !== (val || '')) sel.value = val || ''; return; }
        g.querySelectorAll('input[type="radio"]').forEach(function (i) {
          var want = (val !== null && i.value === val);
          if (i.checked !== want) i.checked = want;
        });
      }
      function showEl(el, show) {
        var want = show ? '' : 'none';
        if (el.style.display !== want) el.style.display = want;
      }
      function visibleValues(idx, sel) {
        var out = [];
        variants.forEach(function (opts) {
          for (var i = 0; i < idx; i++) { if (sel[i] && opts[i] !== sel[i]) return; }
          if (out.indexOf(opts[idx]) === -1) out.push(opts[idx]);
        });
        return out;
      }
      function isComplete(sel) {
        if (sel.some(function (v) { return !v; })) return false;
        return variants.some(function (opts) { return opts.every(function (o, i) { return o === sel[i]; }); });
      }

      var applying = false;
      function apply() {
        if (applying) return;
        var vs = getVS();
        if (!vs) return;
        var groups = getGroups(vs);
        if (groups.length < 2) return;
        applying = true;
        try {
          var sel = groups.map(valueOf);
          for (var idx = 0; idx < groups.length; idx++) {
            if (idx > 0 && !sel[idx - 1]) { if (sel[idx]) { setValue(groups[idx], null); sel[idx] = null; } continue; }
            if (sel[idx] && visibleValues(idx, sel).indexOf(sel[idx]) === -1) { setValue(groups[idx], null); sel[idx] = null; }
          }
          groups.forEach(function (g, i) {
            var sectionOn = i === 0 || !!sel[i - 1];
            showEl(g, sectionOn);
            if (!sectionOn) return;
            var vis = visibleValues(i, sel);
            g.querySelectorAll('input[type="radio"]').forEach(function (input) {
              var show = vis.indexOf(input.value) !== -1;
              showEl(input, show);
              var label = vs.querySelector('label[for="' + input.id + '"]');
              if (label) showEl(label, show);
            });
          });
          var info = vs.closest('.product-info') || document.body;
          info.classList.toggle('jp-picker-locked', !isComplete(sel));
        } finally { applying = false; }
      }

      var pending = null;
      function schedule() {
        if (pending) return;
        pending = setTimeout(function () { pending = null; apply(); }, 60);
      }

      // start clean: nothing selected, only the Model section visible
      var vs0 = getVS();
      if (vs0) getGroups(vs0).forEach(function (g) { setValue(g, null); });
      apply();

      document.addEventListener('change', function (e) {
        var vs = getVS();
        if (vs && e.target !== vs && vs.contains(e.target)) schedule();
      });
      var mo = new MutationObserver(schedule);
      mo.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('submit', function (e) {
        var vs = getVS();
        if (!vs) return;
        var groups = getGroups(vs);
        var sel = groups.map(valueOf);
        var radio = vs.querySelector('input[type="radio"]');
        var formId = radio ? radio.getAttribute('form') : null;
        if (e.target && e.target.id === formId && !isComplete(sel)) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }
  });
})();
